import { Avatar as BaseAvatar, styled } from '@arpeggi/ui'

const Root = styled('div', {
  display: 'flex',
  alignItems: 'center',
  padding: '12px 16px',
  flexBasis: '270px',
  flexShrink: 0,
  flexGrow: 0,
  boxSizing: 'border-box',
  maxWidth: '270px',
  gap: '12px'
})

const Avatar = styled(BaseAvatar, {
  width: '40px',
  height: '40px',
  flexShrink: 0
})

const Overlay = styled('div', {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: '$blackA500',
  transition: 'all 100ms ease',
  opacity: 0,
  '& > svg': {
    width: '20px',
    height: '20px',
    color: '$white'
  }
})

const Icon = styled('div', {
  flexShrink: 0,
  width: '16px',
  height: '16px'
})

const Content = styled('div', {
  flex: 1,
  maxWidth: '186px'
})

const Title = styled('div', {
  display: 'block',
  width: '100%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  text: '14',
  fontWeight: '$bold',
  color: '$blackA900',
  '&:hover': { textDecoration: 'underline' }
})

const ArtistName = styled('div', {
  display: 'block',
  overflow: 'hidden',
  width: '100%',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  text: '14',
  color: '$blackA600',
  '&:hover': { textDecoration: 'underline' }
})

export const MainColumn = { Root, Avatar, Icon, Content, Title, ArtistName, Overlay }
